import { useDialog } from '@dni-hooks/useDialog'
import { Button } from '@pets-ui/Button/Button'
import { Dialog } from '@pets-ui/Dialog/Dialog'
import { DialogActions } from '@pets-ui/DialogActions/DialogActions'
import { DialogContent } from '@pets-ui/DialogContent/DialogContent'
import { DialogHeader } from '@pets-ui/DialogHeader/DialogHeader'
import { Text } from '@pets-ui/Text/Text'
import { useTranslation } from 'react-i18next'
import cartUiI18nInstance from '../i18n/i18nConfig'

export const DIALOG_VALIDATE_STOCK = 'DIALOG_VALIDATE_STOCK'

export interface DialogValidateStockProps {
  onConfirm?: () => void
  productName?: string
  leftQuantity?: number
}

export const DialogValidateStock = () => {
  const { open, closeDialog, onConfirm, productName, leftQuantity } = useDialog<DialogValidateStockProps>(DIALOG_VALIDATE_STOCK)
  const { t } = useTranslation('cartUi', { i18n: cartUiI18nInstance })

  const handleConfirm = () => {
    closeDialog()
    onConfirm?.()
  }

  const insufficientStockMessage = productName && leftQuantity !== undefined
    ? t('cartUi.insufficientStockDetail', { productName, leftQuantity, defaultValue: '「{{productName}}」庫存僅剩 {{leftQuantity}} 件，請調整購買數量或改選其他品項' })
    : t('cartUi.insufficientStockAction', { defaultValue: '在您瀏覽的過程中有商品或贈品已無庫存，請移除或改選其他品項' })

  return (
    <Dialog open={open} maxWidth={320}>
      <DialogHeader align="center" title={t('cartUi.insufficientStock', { defaultValue: '庫存不足' })} onClose={closeDialog} />
      <DialogContent>
        <Text>{insufficientStockMessage}</Text>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleConfirm}
          width="100%"
        >
          {t('cartUi.confirm', { defaultValue: '確定' })}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
